import { defineMessages } from 'react-intl';

export const messages: {
	alternativeButtonStyleLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	buttonHeading: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	defaultButtonStyleLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	deleteIconLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	textPlaceholder: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	buttonHeading: {
		id: 'company-hub.company-hub-common.spotlight.spotlight-config-panel.button-heading',
		defaultMessage: 'Button',
		description: 'Heading for Spotlight button popup',
	},
	textPlaceholder: {
		id: 'company-hub.company-hub-common.spotlight.spotlight-config-panel.button-text-placeholder',
		defaultMessage: 'View',
		description: 'Label for text input placeholder of Spotlight button',
	},
	deleteIconLabel: {
		id: 'company-hub.company-hub-common.spotlight.spotlight-config-panel.delete-icon-label',
		defaultMessage: 'Delete',
		description: 'Label for delete icon shown in button config popup to delete the targeted button',
	},
	defaultButtonStyleLabel: {
		id: 'company-hub.company-hub-common.spotlight.spotlight-config-panel.light-button-style-label',
		defaultMessage: 'Default',
		description:
			'Label for light button style option shown in button config popup to change the style of the button to light appearance',
	},
	alternativeButtonStyleLabel: {
		id: 'company-hub.company-hub-common.spotlight.spotlight-config-panel.dark-button-style-label',
		defaultMessage: 'Alternative',
		description:
			'Label for dark button style option shown in button config popup to change the style of the button to dark appearance',
	},
});
